import crud from '@/store/crud';
import http from '@/http';

const types = {
    GENERATE_API_KEY: 'GENERATE_API_KEY',
};

const crudStore = crud('customers');

// state
export const state = crudStore.state;

// mutations
export const mutations = {
    [types.GENERATE_API_KEY](state, key) {
        state.customer.apiKeys.push(key);
    },
    ...crudStore.mutations,
};

// actions
export const actions = {
    ...crudStore.actions,
    async saveApiKeys({ state: { customer } }) {
        for (const apiKey of customer.apiKeys) {
            await http.patch(`/customers/${customer.id}/api-keys/${apiKey.key}`, apiKey);
        }
    },
    generateApiKey({ commit, state: { customer } }, resource) {
        return http.post(`/customers/${customer.id}/api-keys`)
            .then(key => {
                commit(types.GENERATE_API_KEY, key);

                return key;
            });
    },
    updateMeasureAccess({ state: { customer: { id } } }, measures) {
        return http.put(`customers/${id}/measure-access`, { measures });
    },
};

// getters
export const getters = {};
